import { Chip, CircularProgress } from '@mui/material';
import React from 'react';
import { Channel, ChannelId } from '../../shared/Post';
import { lang, translateContent } from '../../globals/Translations';
import colors from '../../globals/colors';
import { TranslatedTerms } from '../../globals/TranslatedTerms';
import { updateInvestorChannels } from '../../globals/ApiHooks';
import { RowFlexBox } from '../templates/Wrappers';
import { InvestorId } from '../../shared/Investor';

type ChannelItemProps = { channel: Channel, subscribedChannels: ChannelId[], onChannelUpdate(channels: ChannelId[]): void, investorId: InvestorId }

const ChannelItem: React.FC<ChannelItemProps> = ({ channel, subscribedChannels, onChannelUpdate, investorId }) => {
    const [loading, setLoading] = React.useState(!subscribedChannels)

    const handleChecked = async (state: boolean) => {
        setLoading(true)
        await updateInvestorChannels({
            investorId,
            addAction: state,
            affecredChannel: channel.id
        })
        if (state) onChannelUpdate([...subscribedChannels, channel.id])
        else onChannelUpdate(subscribedChannels.filter((item) => item !== channel.id))
        setLoading(false)
    }

    const checked = subscribedChannels.filter((id) => id === channel.id).length > 0
    return (
        <RowFlexBox onClick={() => handleChecked(!checked)} className="hoverEffect clickable" style={{
            justifyContent: 'space-between', alignItems: 'center', textAlign: 'left',
            paddingBottom: 4, paddingTop: 4, paddingLeft: 5, paddingRight: 10, borderRadius: 10
        }}>
            <span style={{ marginLeft: 4, fontSize: 12 }}>{translateContent(channel.title)}</span>
            <Chip
                style={checked ? { backgroundColor: colors.primary } : {}}
                disabled={loading} clickable
                icon={loading ? <CircularProgress size={20} /> : <span></span>}
                color={checked ? "primary" : "default"}
                label={(checked ? lang(TranslatedTerms.FOLLOWING) : lang(TranslatedTerms.FOLLOW))}
            />
        </RowFlexBox>
    )
}

const channelsSort = (a: Channel, b: Channel) => translateContent(a.title).localeCompare(translateContent(b.title))

type SubscriptionListProps = { projectChannels?: Channel[], defaultChannels?: Channel[], investorChannels?: string[], investorId: InvestorId, mobile?: boolean }

const SubscriptionList: React.FC<SubscriptionListProps> = ({ projectChannels, defaultChannels, investorChannels, investorId }) => {
    const [channelsLocal, setChannelsLocal] = React.useState(projectChannels?.sort(channelsSort))
    const [subscribedChannelsLocal, setSubscribedChannelsLocal] = React.useState(investorChannels || [])

    const [searchTerm, setSearchTerm] = React.useState('')

    const updateChannels = (term?: string) => {
        if (!term) setChannelsLocal(projectChannels)
        else {
            const result = projectChannels?.filter((item) => translateContent(item.title).toLowerCase().includes(term.toLocaleLowerCase()));
            setChannelsLocal(result)
            setSearchTerm(term)
        }
    }

    React.useEffect(() => {
        updateChannels()
        if(investorChannels) setSubscribedChannelsLocal(investorChannels)
    }, [projectChannels, investorChannels])

    return (
        <div>
            <div className="card padding">
                <h4>{lang(TranslatedTerms.SUBSCRIPTION_LIST)}</h4>
                <div>
                    {defaultChannels && defaultChannels.map((item, key) => <ChannelItem channel={item} subscribedChannels={subscribedChannelsLocal}
                        key={key} onChannelUpdate={setSubscribedChannelsLocal} investorId={investorId} />)}
                </div>
                <h4>{lang(TranslatedTerms.PROJECT_NEWS)}</h4>
                <input style={{ width: '100%', marginBottom: 10 }} placeholder="Søg"
                    defaultValue={searchTerm} onChange={(e) => updateChannels(e.target.value)} />
                <div>
                    {channelsLocal && channelsLocal.map((item, key) => <ChannelItem channel={item} subscribedChannels={subscribedChannelsLocal}
                        key={key} onChannelUpdate={setSubscribedChannelsLocal} investorId={investorId} />)}
                </div>
            </div>
        </div>
    );
};

export default SubscriptionList;